import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import About_Us from "./components/about_us/About_Us";
import Privacy_Policy from "./components/privacy_policy/Privacy_Policy";
import Terms_Conditions from "./components/terms_conditions/Terms_Conditions";
import Contact_Us from "./components/contact_us/Contact_Us";
import Services from "./components/services/Services";
import Maintenance from "./components/services/maintenance/Maintenance";
import Body_Repair from "./components/services/body_repair/Body_Repair";
import Outstation_Rides from "./components/services/outstation_rides/Outstation_Rides";
import Car_Wash from "./components/services/car_wash/Car_Wash";
import Inspection from "./components/services/insepection/Insepection";
import Pickup from "./components/services/pickup/Pickup";
import Towing from "./components/services/towing/Towing";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

function App() {
  return (
    <>
      <ScrollToTop/> 
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/services/:type" element={<Services />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/body-repair" element={<Body_Repair />} />
        <Route path="/outstation-rides" element={<Outstation_Rides />} />
        <Route path="/car-wash" element={<Car_Wash />} />
        <Route path="/pickup" element={<Pickup />} />
        <Route path="/inspection" element={<Inspection />} />
        <Route path="/towing" element={<Towing />} />
        <Route path="/contact-us" element={<Contact_Us/>}/> 
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
        <Route path="/terms-conditions" element={<Terms_Conditions />} />

      </Routes>
      <Footer />
    </>
  );
}

export default App;
